import React, { useState, useMemo } from "react";
import AllPropertiesContext from "./AllPropertiesContext";

const AllPropertiesState = (props) => {
  const [state, setState] = useState([]);
  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );

  return (
    <AllPropertiesContext.Provider value={value}>
      {props.children}
    </AllPropertiesContext.Provider>
  );
};

export default AllPropertiesState;
